module.exports = __webpack_public_path__ + "static/HR Portal Meine Daten Arbeitszeugnisse-0931ddff954afe8b6ac470752561ecaf.jpg";